module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f641a96c9e9840b7eca4df592057d79c.png";